<template>
  <div>
    <v-row justify="center">
      <v-col cols="12" lg="10" md="10" sm="12" xs="12">
        <loader />
        <div class="event-title-row">
          <div class="title-custom">{{ $t('EVENTS.title') }}</div>
          <v-btn
            id="events-create-button"
            dark
            color="blue"
            @click="$router.push('/dashboard/program/new')"
          >
            {{ $t('EVENTS.create_button') }}
            <v-icon dark class="ml-2">{{ icons.mdiPlus }}</v-icon>
          </v-btn>
        </div>
        <EventTabs
          :isAdmin="true"
          :dayOneEvents="dayOneEvents"
          :dayTwoEvents="dayTwoEvents"
          :dayThreeEvents="dayThreeEvents"
          :showCalendar="true"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Loader from "@/components/atoms/Loader.vue";
import EventTabs from "@/components/organisms/EventTabs.vue";
import { mdiPlus } from "@mdi/js";

export default {
  components: {
    Loader,
    EventTabs,
  },
  data: () => ({
    icons: {
      mdiPlus,
    },
  }),
  computed: {
    snackbar() {
      return this.$store.state.snackbar.snackbar;
    },
    events() {
      return this.$store.state.talk.talks;
    },
    dayOneEvents() {
      return this.events?.filter((e) => {
        return e.schedule.day.toLowerCase().includes("2021-09-08");
      });
    },
    dayTwoEvents() {
      return this.events?.filter((e) => {
        return e.schedule.day.toLowerCase().includes("2021-09-09");
      });
    },
    dayThreeEvents() {
      return this.events?.filter((e) => {
        return e.schedule.day.toLowerCase().includes("2021-09-10");
      });
    },
  },
  methods: {
    newEvent() {
      this.$router.push("/dashboard/program/new");
    },
  },
  async created() {
    await this.$store.dispatch("getTalks");
  },
};
</script>

<style scoped>
.title-custom {
  font-size: 28px;
  font-weight: 300;
  margin: 3% 0% 1% 1%;
}

.new-btn {
  margin: 3% 0% 1% 1%;
  color: #fff;
}

.event-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.event-title-row .v-btn {
  margin-top: 3%;
  margin-right: 8px;
}

@media (max-width: 390px) {
  .event-title-row {
    flex-direction: column;
    margin-bottom: 24px;
  }
  
  .event-title-row .v-btn {
    margin-right: 0;
    margin-top: 0;
  }
}
</style>
